import { generateClassName } from '@klv/shared/utils/functions';

import * as s from './styles/eyebrow.module.css';

import type { TEyebrowProps, TTag } from './types';

const Eyebrow = <T extends TTag>({ content, className, tag, textColor, ...props }: TEyebrowProps<T>) => {
  const Component = tag || 'div';

  return (
    <Component
      {...props}
      className={generateClassName([s.eyebrow, textColor && s[textColor], 'eyebrow', className])}
    >
      {content}
    </Component>
  );
};

export default Eyebrow;
